import styled from 'styled-components';

export const RuleSummaryStyled = styled.div`
  .Polaris-ShadowBevel {
    box-shadow: none;
    border-radius: 0;
    .custom-card-header .Polaris-Text--root {
      font-weight: 650;
    }
    .Polaris-Text--root {
      font-size: 13px;
      font-weight: 600;
    }
    &::before {
      box-shadow: none;
    }
  }
`;
